import React from 'react';
import ReactDOM from 'react-dom/client';
import { TicoticketApp } from './TicoticketApp.tsx';
import './styles.css';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store';
import { Provider } from 'react-redux';


import mapboxgl from 'mapbox-gl'; // or "const mapboxgl = require('mapbox-gl');"

mapboxgl.accessToken = 'pk.eyJ1IjoiY29zdGFsb2dpYyIsImEiOiJjbGV4aXB2YjYwOGI4NDNvMG9jZTdkMjdkIn0.rGP3MnTr1REG2QVDUX70kQ';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <TicoticketApp />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
)
